import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface StyledBoxProps {
  layoutHeightLG: number;
  layoutHeightSM: number;
}

const StyledBox = styled(Box)<StyledBoxProps>(
  ({ theme, layoutHeightLG, layoutHeightSM }) => ({
    paddingTop: `calc(${theme.spacing(layoutHeightLG)} + ${theme.spacing(5)})`,
    [theme.breakpoints.down('lg')]: {
      paddingTop: `calc(${theme.spacing(layoutHeightSM)} + ${theme.spacing(
        5,
      )})`,
    },
    '& .BVContainer': {
      [theme.breakpoints.up('lg')]: {
        maxWidth: theme.typography.pxToRem(1440),
      },
    },
  }),
);

export default StyledBox;
